import styled from "styled-components";

export const Conteiner = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;


    margin: auto;
    gap: 20px;
    padding: 22,5px;
    background-color: #212529;

    padding: 10px;
    h1{
        color: #F8F9FA;
        font-weight: 700;
        font-size: 18px;
        line-height: 28px;
        margin-top: 42px;
    }
    span{
        font-weight: 600;
        font-size: 12px;
        line-height: 18px;
        color: #868E96;

    }
    @media screen and (min-width: 720px) {
        width:400px;
    }
` ;

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    gap: 10px;

    color: #F8F9FA;
    font-weight: 400;
    font-size: 16.2426px;
    line-height: 26px;
    min-height: 300px;
    width: 100%;


    div{
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        width: 100%;
    }
    label{
        font-weight: 400;
        font-size: 12.182px;

        text-align: left;
    }

    input{
        background: #343B41;
        border-radius: 4px;
        padding: 10.5px;
        width: 94%;
        max-height: 40px;
        min-height: 30px;
        border: none;    
}

    a{        
        padding: 10.5px;
        border-radius: 4px;
        background:#868E96;

        color: #ffff;
        font-weight: 500;
        font-size: 16px;

        width: 95%;

        text-decoration: none;
    }
    .inputSelectModule{
        background-color: #343B41;
        border-radius: 4px;
    }
    .MuiInputLabel-root{
        color: #F8F9FA;
    }
    .MuiSvgIcon-root{
        color: #F8F9FA;
    }    
    .MuiSelect-select{
        color: #F8F9FA;
    }

` ;

export const Btn = styled.button`
        padding: 10.5px;
        margin-top: 20px;
        border-radius: 4px;
        background: ${(props)=>props.color};

        color: #ffff;
        font-weight: 500;
        font-size: 16px;

        width: 100%;
        height: 48px;
        border: none;

        cursor: pointer;

        &:hover {
    transform: scale(1.01);
    transition: all 0.4s;
    }
` ;

export const DivMain = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    gap: 25px;

    header{
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;

    }
    .linkVoltar{
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #212529;
        color: #F8F9FA;
        border-radius: 4px;
        text-decoration: none;
        width: 60px;
        height: 35px;
    }
    .logo-cadastro{
        height: 21px;
    }
` ;

export const BtnVoltar = styled.button`
    padding: 10px 16px;
    background-color: #212529;
    border: none;
    color: #ffffff;
    font-weight: 600;
    font-size: 12px;

    cursor: pointer;
    
    &:hover{
        background-color: #3e4c5a;
    transform: scale(1.08);
    transition: all 0.4s;
    }
` ;